import { ICatalogSummary } from "shared/hubrise/models"

export const sortCatalogSummaries = (catalogSummaries: Array<ICatalogSummary>): Array<ICatalogSummary> => {
  return [...catalogSummaries].sort((a, b) => a.name.localeCompare(b.name))
}
